import React, { useEffect } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    useTheme,
} from "@mui/material";
import Aos from "aos";
import "aos/dist/aos.css";

const services = [
    {
        id: "01",
        title: "Banking Services",
        desc:
            "Apply for credit cards from top banks, compare benefits, and manage everything securely with fast, paperless support.",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/banking.png",
    },
    {
        id: "02",
        title: "Insurance",
        desc:
            "Investments, insurance plans, service benefits, and smart banking — curated with clarity for government and public sector employees",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/insurance.png",
    },
    {
        id: "03",
        title: "Investment Services",
        desc:
            "Start SIPs or lump-sum investments in mutual funds with goal-based guidance and smart tools.",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/investment",
    },
    {
        id: "04",
        title: "Service Benefits",
        desc:
            "In-app support, FAQs, financial guides, and updates to make your financial life simpler and stress-free.",
        img: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/service",
    },
];

const OurServicesNew = () => {
    const theme = useTheme();

    useEffect(() => {
        Aos.init({
            duration: 1000,
            easing: "ease-out-cubic",
            once: true,
        });
    }, []);

    return (
        <Box sx={{
            py: { xs: 5, md: 7 },
            background: `
          radial-gradient(
            circle at 15% 20%,
            ${theme.palette.primary.main}55,
            transparent 45%
          ),
          radial-gradient(
            circle at 85% 25%,
            ${theme.palette.tertiary.main}88,
            transparent 45%
          ),
          radial-gradient(
            circle at 50% 75%,
            ${theme.palette.primary.main}33,
            transparent 55%
          ),
          linear-gradient(
            135deg,
            #ffffff 0%,
            ${theme.palette.secondary.main} 50%,
            #ffffff 100%
          )
        `,
        }}>
            <Container maxWidth="lg">

                {/* HEADER */}
                <Box sx={{ mb: { xs: 3, md: 4 }, }}>



                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                        }}
                    >
                        Explore Our{" "}
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            Financial</Box>{" "}
                        Suite
                    </Typography>


                </Box>

                {/* SERVICES GRID */}
                <Grid container spacing={{ xs: 2.5, md: 3 }}>
                    {services.map((item, index) => (
                        <Grid item xs={12} sm={6} key={item.id}>
                            <Box
                                sx={{
                                    height: "100%",
                                    p: 3,
                                    borderRadius: "18px",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #e6edf5",
                                    boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
                                    transition: "0.25s ease",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 2,
                                    "&:hover": {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0px 18px 40px rgba(0,0,0,0.08)",
                                    },
                                }}
                            >
                                {/* IMAGE LEFT */}
                                <Box
                                    sx={{
                                        width: 60,
                                        height: 60,
                                        borderRadius: "14px",
                                        backgroundColor: theme.palette.primary.main,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={item.img}
                                        alt={item.title}
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            objectFit: "contain",
                                            filter: "brightness(0) invert(1)",
                                        }}
                                    />
                                </Box>

                                <Box>
                                    <Typography
                                        sx={{
                                            fontSize: 17,
                                            fontWeight: 700,
                                            color: theme.palette.text.primary,
                                            mb: 0.5,
                                        }}
                                    >
                                        {item.title}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontSize: "14px",
                                            color: theme.palette.text.secondary,
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        {item.desc}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                    ))}
                </Grid>

            </Container>
        </Box>
    );

};

export default OurServicesNew;
